import { isDefined, isEmpty, isNotDefined } from '@sgme/fp';
import { useReadonlyField } from 'components/common-form/contexts/readonly/FieldMetadataContext';
import { SummaryFieldRow } from 'components/common-form/sidePanel/docToolbar/summary/builder/node/SummaryFieldRow';
import { FormattedMessage } from 'components/shared/Intl';
import { IntlKey } from 'locales';
import { DistributionCountryReadonlyValueDefinition } from 'models/metadata/readonlyValue.definition';
import { FC } from 'react';

interface ProductSummaryDistributionCountryProps {
  node: DistributionCountryReadonlyValueDefinition;
}

export const ProductSummaryDistributionCountryField: FC<ProductSummaryDistributionCountryProps> = ({ node }) => {
  const data = useReadonlyField().getMetadataWithData(node);

  const translationKey = node.translationKey ?? node.id;

  const translations = node.availableDistributionCountries;
  const dataToDisplay =
    isNotDefined(data) || isEmpty(data)
      ? 'None'
      : data.map(x => translations?.[x.DistributionCountryCountry]).join(', ');

  return (
    <SummaryFieldRow labelKey={translationKey} id={node.id}>
      <p className="text-large fw-light m-0" data-e2e={`product-summary-field-${node.id}`}>
        {isDefined(dataToDisplay) && (
          <FormattedMessage id={`field.${dataToDisplay}` as IntlKey} defaultMessage={dataToDisplay} />
        )}
      </p>
    </SummaryFieldRow>
  );
};

ProductSummaryDistributionCountryField.displayName = 'ProductSummaryDistributionCountryField';
